// extracted by mini-css-extract-plugin
export default {"infoWork":"balloonContent-module__infoWork--Sq_Og"};